export const trackerFaqs = [
  {
    question: "ردیاب برای یافتن کلیدهای قیمتی گمشده چطور عمل می‌کند؟",
    answer: "به جاکلیدی وصل شده، با تپ اپ صدای بوق می‌زند تا دقیق پیدا شود؛ مثلاً زیر مبل. ابعاد کوچک و باتری طولانی، آن را برای اشیاء روزمره ارزشمند مناسب می‌سازد."
  },
  {
    question: "چگونه ردیاب هشدار خروج کودک از محدوده امن را می‌دهد؟",
    answer: "ردیاب در کوله‌پشتی کودک، با GPS ترکیبی، خروج از حصار جغرافیایی (مانند خانه یا مدرسه) را تشخیص داده و نوتیفیکیشن فوری با لوکیشن زنده روی نقشه به والدین ارسال می‌کند. این ویژگی نظارت ایمن را بدون مزاحمت روزانه فراهم می‌آورد."
  },
  {
    question: "ترکیب ویبره و زنگ در ردیاب برای خیابان‌های شلوغ کودکان چگونه است؟",
    answer: "پروفایل ویبره + زنگ بلند، هشدارها را در محیط‌های پرسر و صدا تضمین می‌کند؛ مثلاً عبور از خیابان. این تنظیم، ایمنی کودکان را بدون از دست رفتن اعلان‌ها حفظ می‌کند."
  },
  {
    question: "دکمه SOS ردیاب در موقعیت‌های اضطراری کودکان چگونه عمل می‌کند؟",
    answer: "با فشردن دکمه SOS، ردیاب لوکیشن و تماس اضطراری را بلافاصله برای والدین یا خانواده ارسال می‌کند؛ ایده‌آل برای گم شدن در بازار شلوغ. سادگی آن، کودکان را بدون ترس به استقلال تشویق می‌کند."
  },
  {
    question: "ردیابی زنده کوله‌پشتی کودک با ردیاب چطور انجام می‌شود؟",
    answer: "ردیاب کوچک در جیب مخفی کوله، موقعیت را لحظه‌ای روی نقشه نشان می‌دهد بدون حس وزن اضافی؛ عالی برای مسیر مدرسه. این ویژگی والدین را از ایمنی کودک آگاه نگه می‌دارد."
  },
  {
    question: "یافتن حیوان خانگی مثل گربه با ردیاب لحظه‌ای چگونه است؟",
    answer: "قلاده گربه با ردیاب، مسیر حرکت را روی گوشی دنبال می‌کند؛ مفید برای شب‌های دیرهنگام در حیاط. موقعیت‌یابی ترکیبی، آزادی حیوان را با نظارت آسان ترکیب می‌کند."
  }
];